<div class="layout-col full">
  <span style="width: 95vw"></span>

  <app-work-center-detail class="flex" [workCenter]="workCenter" (closeRequest)="onClose($event)">
  </app-work-center-detail>
</div>
